<template>
  <div class="elite-content_sidebar_level1_menu_wrapper">
    <ul>
      <li>
        <router-link
          :to="{ name: 'Dashboard' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9602 15.4086H4.04648C2.85835 15.4086 1.74734 14.762 1.14703 13.7209C0.39662 12.4197 0 10.9367 0 9.43245C0 5.71805 2.32218 2.36836 5.87344 1.21353C7.03465 0.835896 8.25592 0.715974 9.50331 0.857079C13.2907 1.28544 16.3347 4.30388 16.9016 8.12367C17.2049 10.1671 16.8038 12.167 15.7414 13.9073C15.1761 14.8334 14.1104 15.4086 12.9602 15.4086ZM8.49775 2.12808C4.41189 2.12808 1.32804 5.47568 1.32804 9.43245C1.32804 10.7042 1.66328 11.9577 2.29748 13.0575C2.66137 13.6886 3.33156 14.0806 4.04648 14.0806H12.9602C13.6508 14.0806 14.2821 13.749 14.608 13.2153C15.5062 11.7438 15.8451 10.0506 15.588 8.31862C15.1048 5.06283 12.5413 2.53719 9.35408 2.17669C9.06977 2.14443 8.78388 2.1282 8.49775 2.12808Z"
                  fill="white"
                />
                <path
                  d="M13.679 10.0963C13.3123 10.0963 13.015 9.79899 13.015 9.43225C13.015 6.82583 11.0316 4.7841 8.49964 4.7841C5.96766 4.7841 3.98429 6.82583 3.98429 9.43225C3.98429 9.79899 3.68701 10.0963 3.32027 10.0963C2.95353 10.0963 2.65625 9.79899 2.65625 9.43225C2.65625 6.1136 5.21443 3.45605 8.49964 3.45605C11.7791 3.45605 14.343 6.10746 14.343 9.43225C14.343 9.79899 14.0458 10.0963 13.679 10.0963Z"
                  fill="white"
                />
                <path
                  d="M7.9232 10.4308L9.78356 7.2085C10.2225 6.44829 11.3733 7.11115 10.9337 7.87252L9.07332 11.0948C8.634 11.8558 7.48382 11.1917 7.9232 10.4308Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.DASHBOARD") }}
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_CRM)"
          :to="{ name: 'Crm Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.6923 0.587036H3.30769C2.84101 0.587036 2.39345 0.772424 2.06346 1.10242C1.73346 1.43241 1.54808 1.87997 1.54808 2.34665V4.10627H0.961538C0.805979 4.10627 0.65679 4.16806 0.546793 4.27806C0.436796 4.38806 0.375 4.53725 0.375 4.6928C0.375 4.84836 0.436796 4.99755 0.546793 5.10755C0.65679 5.21755 0.805979 5.27934 0.961538 5.27934H1.54808V8.21204H0.961538C0.805979 8.21204 0.65679 8.27383 0.546793 8.38383C0.436796 8.49383 0.375 8.64301 0.375 8.79857C0.375 8.95413 0.436796 9.10332 0.546793 9.21332C0.65679 9.32332 0.805979 9.38511 0.961538 9.38511H1.54808V12.3178H0.961538C0.805979 12.3178 0.65679 12.3796 0.546793 12.4896C0.436796 12.5996 0.375 12.7488 0.375 12.9043C0.375 13.0599 0.436796 13.2091 0.546793 13.3191C0.65679 13.4291 0.805979 13.4909 0.961538 13.4909H1.54808V15.2505C1.54808 15.7172 1.73346 16.1647 2.06346 16.4947C2.39345 16.8247 2.84101 17.0101 3.30769 17.0101H12.6923C13.4701 17.0101 14.216 16.7011 14.766 16.1511C15.316 15.6012 15.625 14.8552 15.625 14.0774V3.51973C15.625 2.74193 15.316 1.99599 14.766 1.446C14.216 0.896015 13.4701 0.587036 12.6923 0.587036ZM14.4519 14.0774C14.4519 14.5441 14.2665 14.9917 13.9365 15.3217C13.6066 15.6516 13.159 15.837 12.6923 15.837H3.30769C3.15213 15.837 3.00294 15.7752 2.89295 15.6652C2.78295 15.5552 2.72115 15.4061 2.72115 15.2505V13.4909H3.30769C3.46325 13.4909 3.61244 13.4291 3.72244 13.3191C3.83243 13.2091 3.89423 13.0599 3.89423 12.9043C3.89423 12.7488 3.83243 12.5996 3.72244 12.4896C3.61244 12.3796 3.46325 12.3178 3.30769 12.3178H2.72115V9.38511H3.30769C3.46325 9.38511 3.61244 9.32332 3.72244 9.21332C3.83243 9.10332 3.89423 8.95413 3.89423 8.79857C3.89423 8.64301 3.83243 8.49383 3.72244 8.38383C3.61244 8.27383 3.46325 8.21204 3.30769 8.21204H2.72115V5.27934H3.30769C3.46325 5.27934 3.61244 5.21755 3.72244 5.10755C3.83243 4.99755 3.89423 4.84836 3.89423 4.6928C3.89423 4.53725 3.83243 4.38806 3.72244 4.27806C3.61244 4.16806 3.46325 4.10627 3.30769 4.10627H2.72115V2.34665C2.72115 2.19109 2.78295 2.0419 2.89295 1.93191C3.00294 1.82191 3.15213 1.76011 3.30769 1.76011H12.6923C13.159 1.76011 13.6066 1.9455 13.9365 2.27549C14.2665 2.60548 14.4519 3.05305 14.4519 3.51973V14.0774Z"
                  fill="white"
                />
                <path
                  d="M9.17308 8.79851C9.63711 8.79851 10.0907 8.66091 10.4765 8.40311C10.8624 8.14531 11.1631 7.77889 11.3406 7.35019C11.5182 6.92149 11.5647 6.44975 11.4742 5.99464C11.3836 5.53954 11.1602 5.12149 10.8321 4.79337C10.5039 4.46526 10.0859 4.24181 9.63079 4.15128C9.17568 4.06076 8.70395 4.10722 8.27525 4.28479C7.84654 4.46237 7.48012 4.76308 7.22232 5.1489C6.96453 5.53473 6.82693 5.98833 6.82693 6.45236C6.82693 7.07459 7.07411 7.67135 7.5141 8.11134C7.95409 8.55133 8.55084 8.79851 9.17308 8.79851ZM9.17308 5.27928C9.40509 5.27928 9.6319 5.34808 9.82481 5.47698C10.0177 5.60588 10.1681 5.78909 10.2569 6.00344C10.3456 6.21779 10.3689 6.45366 10.3236 6.68121C10.2784 6.90877 10.1666 7.11779 10.0026 7.28185C9.83851 7.4459 9.62949 7.55763 9.40194 7.60289C9.17438 7.64816 8.93851 7.62493 8.72416 7.53614C8.50981 7.44735 8.3266 7.29699 8.1977 7.10408C8.0688 6.91117 8 6.68437 8 6.45236C8 6.14124 8.1236 5.84286 8.34359 5.62287C8.56358 5.40287 8.86196 5.27928 9.17308 5.27928ZM10.3462 9.38505H8C7.22221 9.38505 6.47626 9.69403 5.92628 10.244C5.37629 10.794 5.06731 11.5399 5.06731 12.3177V12.9043C5.06731 13.0598 5.12911 13.209 5.2391 13.319C5.3491 13.429 5.49829 13.4908 5.65385 13.4908H12.6923C12.8479 13.4908 12.9971 13.429 13.1071 13.319C13.2171 13.209 13.2788 13.0598 13.2788 12.9043V12.3177C13.2788 11.5399 12.9699 10.794 12.4199 10.244C11.8699 9.69403 11.124 9.38505 10.3462 9.38505ZM6.24039 12.3177C6.24039 11.8511 6.42578 11.4035 6.75577 11.0735C7.08576 10.7435 7.53332 10.5581 8 10.5581H10.3462C10.8128 10.5581 11.2604 10.7435 11.5904 11.0735C11.9204 11.4035 12.1058 11.8511 12.1058 12.3177H6.24039Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.CRM_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <crm-module-menu></crm-module-menu>
            </span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_ELIXIOPAY)"
          :to="{ name: 'ElixioPay Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <i class="fa fa-credit-card"></i>
            </span>
            <span class="text">
              {{ $t("APPS.ELIXIOPAY_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <elixio-pay-module-menu></elixio-pay-module-menu>
            </span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_ESIGN)"
          :to="{ name: 'Esign Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.1026 13.449H2.68621C1.94547 13.449 1.3431 12.8466 1.3431 12.1059C1.3431 11.3652 1.9455 10.7628 2.68621 10.7628H4.02931C4.39999 10.7628 4.70086 10.462 4.70086 10.0913C4.70086 9.72059 4.39999 9.41972 4.02931 9.41972H2.68621C1.20476 9.41972 0 10.6245 0 12.1059C0 13.5874 1.20476 14.7921 2.68621 14.7921H14.1026C14.4733 14.7921 14.7742 14.4913 14.7742 14.1206C14.7742 13.7499 14.4733 13.449 14.1026 13.449Z"
                  fill="white"
                />
                <path
                  d="M15.2496 1.55846C14.2477 0.557847 12.6171 0.556503 11.6131 1.55846L10.5857 2.58594C10.5729 2.59669 10.5574 2.60072 10.5454 2.61281C10.5333 2.62491 10.5292 2.64034 10.5185 2.65309L7.07277 6.09882C6.40928 6.76365 6.04394 7.64742 6.04394 8.58693V10.0912C6.04394 10.4619 6.34481 10.7628 6.7155 10.7628H8.21978C9.1593 10.7628 10.043 10.3974 10.7092 9.73329L15.2489 5.19358C16.2502 4.19163 16.2502 2.56041 15.2496 1.55846ZM9.76032 8.78302C9.34867 9.19333 8.80134 9.41967 8.21978 9.41967H7.38705V8.58693C7.38705 8.00538 7.61336 7.45805 8.023 7.04705L11.0269 4.0432L12.7635 5.77982L9.76032 8.78302ZM14.2993 4.244L13.7131 4.83028L11.9764 3.09365L12.562 2.50806C13.0408 2.02992 13.8205 2.0306 14.2987 2.50806C14.7768 2.98687 14.7768 3.76586 14.2993 4.244Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.ESIGN_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <esign-module-menu></esign-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_DPA)"
          :to="{ name: 'Dpa Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.13559 3.37608V2.15574C9.13559 1.40689 8.52851 0.799805 7.77966 0.799805H2.35593C1.60708 0.799805 1 1.40689 1 2.15574V15.4439C1 16.1927 1.60708 16.7998 2.35593 16.7998H7.77966C8.52851 16.7998 9.13559 16.1927 9.13559 15.4439V14.2235M5.0678 16.7998V15.4439M5.0678 0.799805V2.15574M3.98301 10.9694C4.23037 11.2987 4.6242 11.5117 5.06779 11.5117M5.06779 11.5117C5.81664 11.5117 6.42373 10.9046 6.42373 10.1557C6.42373 9.40689 5.81664 8.7998 5.06779 8.7998C4.31895 8.7998 3.71186 8.19272 3.71186 7.44387C3.71186 6.69503 4.31895 6.08794 5.06779 6.08794M5.06779 11.5117V12.8676M5.06779 6.08794C5.51135 6.08794 5.90518 6.30092 6.15257 6.63025M5.06779 6.08794V4.73201M9.92986 6.08794L8.57393 7.44387L9.92986 8.7998M9.13559 7.44387H14.5593M13.765 10.1557L15.1209 11.5117L13.765 12.8676M14.5593 11.5117H9.13559"
                  stroke="white"
                  stroke-width="1.35593"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.DPA_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <dpa-module-menu></dpa-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_SYNC)"
          :to="{ name: 'Sync Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <i class="fas fa-sync"></i>
            </span>
            <span class="text">
              {{ $t("APPS.SYNC_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <sync-module-menu></sync-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_SALES)"
          :to="{ name: 'Sales Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.4496 8.92311C4.73571 8.92311 4.15497 9.50395 4.15497 10.2177C4.15497 10.9316 4.73571 11.5123 5.4496 11.5123C6.16336 11.5123 6.74423 10.9316 6.74423 10.2177C6.74423 9.50395 6.16336 8.92311 5.4496 8.92311ZM5.4496 10.5056C5.2909 10.5056 5.16173 10.3765 5.16173 10.2177C5.16173 10.059 5.2909 9.92994 5.4496 9.92994C5.6083 9.92994 5.73737 10.059 5.73737 10.2177C5.73737 10.3765 5.6083 10.5056 5.4496 10.5056ZM9.7129 8.92311C8.99902 8.92311 8.41827 9.50395 8.41827 10.2177C8.41827 10.9316 8.99902 11.5123 9.7129 11.5123C10.4268 11.5123 11.0075 10.9316 11.0075 10.2177C11.0075 9.50395 10.4268 8.92311 9.7129 8.92311ZM9.7129 10.5056C9.55421 10.5056 9.425 10.3765 9.425 10.2177C9.425 10.059 9.55424 9.92994 9.7129 9.92994C9.87157 9.92994 10.0008 10.059 10.0008 10.2177C10.0008 10.3765 9.8716 10.5056 9.7129 10.5056ZM7.5812 6.90899C7.3032 6.90899 7.0779 7.13432 7.0779 7.41226V13.0232C7.0779 13.3012 7.30323 13.5265 7.58117 13.5265C7.85911 13.5265 8.08463 13.3012 8.08463 13.0233V7.41226C8.08463 7.13425 7.8593 6.90899 7.5812 6.90899Z"
                  fill="white"
                />
                <path
                  d="M17.1853 0.613945C16.9887 0.417357 16.6699 0.417487 16.4733 0.613945L14.6792 2.4082C13.9002 1.78676 12.9414 1.44951 11.9304 1.44951H11.9206C10.7437 1.45205 9.63716 1.91177 8.80501 2.74389L0.991415 10.5575C0.557549 10.9914 0.557549 11.6974 0.991415 12.1312L5.66785 16.8078C5.87817 17.0178 6.15754 17.1337 6.45472 17.1337C6.75202 17.1337 7.03152 17.018 7.24172 16.8078L15.0552 8.99419C15.8875 8.16204 16.3471 7.0555 16.3497 5.87864C16.3518 4.86403 16.0144 3.90157 15.391 3.12004L17.1851 1.32581C17.3818 1.12932 17.3818 0.810532 17.1853 0.613945ZM15.343 5.87646C15.3409 6.78527 14.9859 7.63969 14.3433 8.28235L6.52979 16.0959C6.51998 16.1058 6.50829 16.1137 6.4954 16.119C6.48252 16.1243 6.46869 16.127 6.45475 16.1269C6.44082 16.127 6.42702 16.1243 6.41416 16.119C6.4013 16.1136 6.38964 16.1057 6.37988 16.0958L1.70335 11.4194C1.68345 11.3995 1.67226 11.3725 1.67223 11.3444C1.67221 11.3162 1.68335 11.2892 1.70322 11.2693L9.51688 3.45589C10.1594 2.81322 11.0139 2.4582 11.9227 2.45628H11.9304C12.6719 2.45628 13.3771 2.69115 13.9615 3.12577L13.0423 4.04503C12.4166 3.71605 11.6083 3.80264 11.0638 4.34715C10.4055 5.0056 10.4055 6.07692 11.0638 6.73534C11.3828 7.05439 11.8069 7.23001 12.2579 7.23001C12.709 7.23001 13.1332 7.05426 13.4521 6.73534C13.771 6.41642 13.9468 5.99235 13.9468 5.5412C13.9468 5.26345 13.8799 4.99593 13.7541 4.75687L14.6733 3.83776C15.1095 4.42408 15.3445 5.13204 15.343 5.87646ZM12.7402 5.05896C12.8038 5.12213 12.8541 5.19728 12.8884 5.28005C12.9227 5.36282 12.9403 5.45157 12.94 5.54116C12.94 5.72336 12.8691 5.89469 12.7402 6.02347C12.677 6.08695 12.6019 6.13728 12.5191 6.17155C12.4364 6.20582 12.3476 6.22334 12.2581 6.22312C12.0758 6.22312 11.9045 6.15215 11.7757 6.02347C11.5098 5.75745 11.5098 5.32488 11.7757 5.05896C12.0423 4.79245 12.4736 4.79245 12.7402 5.05896Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.SALES_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <sales-module-menu class="sub-menu"></sales-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_PURCHASES)"
          :to="{ name: 'Purchases Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5877 5.30114H13.0788L11.0524 1.25576C11.0132 1.16153 10.955 1.0764 10.8813 1.0057C10.8077 0.935006 10.7203 0.880252 10.6245 0.844865C10.5288 0.809477 10.4268 0.794216 10.3249 0.800036C10.223 0.805855 10.1234 0.83263 10.0323 0.878687C9.94119 0.924744 9.86057 0.989094 9.79548 1.06771C9.73038 1.14633 9.6822 1.23754 9.65394 1.33562C9.62568 1.4337 9.61796 1.53656 9.63125 1.63776C9.64455 1.73897 9.67857 1.83634 9.7312 1.9238L11.4162 5.30114H4.91385L6.5988 1.9238C6.67085 1.75078 6.67478 1.55691 6.60981 1.38112C6.54483 1.20532 6.41575 1.06061 6.2485 0.976042C6.08124 0.891474 5.88818 0.873308 5.70809 0.925191C5.52799 0.977074 5.37419 1.09517 5.27756 1.25576L3.25115 5.30114H0.742273C0.54541 5.30114 0.35661 5.37935 0.217407 5.51855C0.0782035 5.65775 0 5.84655 0 6.04341C0 6.24028 0.0782035 6.42908 0.217407 6.56828C0.35661 6.70748 0.54541 6.78569 0.742273 6.78569H0.801655L1.26186 12.2934C1.3402 13.2227 1.76554 14.0884 2.45324 14.7184C3.14095 15.3483 4.04062 15.6963 4.97323 15.693H11.3865C12.3191 15.6963 13.2187 15.3483 13.9064 14.7184C14.5942 14.0884 15.0195 13.2227 15.0978 12.2934L15.5283 6.78569H15.5877C15.7846 6.78569 15.9734 6.70748 16.1126 6.56828C16.2518 6.42908 16.33 6.24028 16.33 6.04341C16.33 5.84655 16.2518 5.65775 16.1126 5.51855C15.9734 5.37935 15.7846 5.30114 15.5877 5.30114ZM13.591 12.1672C13.5444 12.725 13.2893 13.2448 12.8767 13.6231C12.464 14.0014 11.924 14.2104 11.3642 14.2084H4.95838C4.39858 14.2104 3.85858 14.0014 3.44592 13.6231C3.03326 13.2448 2.77821 12.725 2.73156 12.1672L2.29362 6.78569H14.0364L13.591 12.1672ZM10.3918 10.4971C10.3918 10.6939 10.3136 10.8827 10.1744 11.0219C10.0352 11.1611 9.84641 11.2393 9.64955 11.2393H8.90727V11.9816C8.90727 12.1785 8.82907 12.3673 8.68987 12.5065C8.55066 12.6457 8.36186 12.7239 8.165 12.7239C7.96814 12.7239 7.77934 12.6457 7.64013 12.5065C7.50093 12.3673 7.42273 12.1785 7.42273 11.9816V11.2393H6.68045C6.48359 11.2393 6.29479 11.1611 6.15559 11.0219C6.01639 10.8827 5.93818 10.6939 5.93818 10.4971C5.93818 10.3002 6.01639 10.1114 6.15559 9.97218C6.29479 9.83298 6.48359 9.75478 6.68045 9.75478H7.42273V9.0125C7.42273 8.81564 7.50093 8.62684 7.64013 8.48764C7.77934 8.34844 7.96814 8.27023 8.165 8.27023C8.36186 8.27023 8.55066 8.34844 8.68987 8.48764C8.82907 8.62684 8.90727 8.81564 8.90727 9.0125V9.75478H9.64955C9.84641 9.75478 10.0352 9.83298 10.1744 9.97218C10.3136 10.1114 10.3918 10.3002 10.3918 10.4971Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.PURCHASES_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <purchases-module-menu class="sub-menu"></purchases-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_INVENTORY)"
          :to="{ name: 'Inventory Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.19667 1.9248C4.00322 1.92481 3.8136 1.97869 3.64904 2.08039C3.48449 2.1821 3.35151 2.32761 3.265 2.50064L2.51125 4.00814H15.4888L14.7346 2.50064C14.6481 2.32774 14.5153 2.18231 14.3509 2.08061C14.1865 1.97891 13.9971 1.92497 13.8037 1.9248H4.19667ZM15.875 5.25814H2.125V14.6331C2.125 14.9094 2.23475 15.1744 2.4301 15.3697C2.62545 15.5651 2.8904 15.6748 3.16667 15.6748H14.8333C15.1096 15.6748 15.3746 15.5651 15.5699 15.3697C15.7653 15.1744 15.875 14.9094 15.875 14.6331V5.25814ZM2.14708 1.94147C2.33745 1.5608 2.63007 1.24066 2.99215 1.01693C3.35423 0.793211 3.77146 0.674742 4.19708 0.674805H13.8033C14.229 0.674742 14.6462 0.793211 15.0083 1.01693C15.3703 1.24066 15.663 1.5608 15.8533 1.94147L17.0592 4.35397C17.1025 4.44067 17.125 4.53624 17.125 4.63314V14.6331C17.125 15.2409 16.8836 15.8238 16.4538 16.2536C16.024 16.6834 15.4411 16.9248 14.8333 16.9248H3.16667C2.55888 16.9248 1.97598 16.6834 1.54621 16.2536C1.11644 15.8238 0.875 15.2409 0.875 14.6331V4.63314C0.875007 4.53624 0.897544 4.44067 0.940833 4.35397L2.14708 1.94147Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.29164 12.9666C6.29164 12.8008 6.35749 12.6418 6.4747 12.5246C6.59191 12.4074 6.75088 12.3416 6.91664 12.3416H11.0833C11.2491 12.3416 11.408 12.4074 11.5252 12.5246C11.6425 12.6418 11.7083 12.8008 11.7083 12.9666C11.7083 13.1323 11.6425 13.2913 11.5252 13.4085C11.408 13.5257 11.2491 13.5916 11.0833 13.5916H6.91664C6.75088 13.5916 6.59191 13.5257 6.4747 13.4085C6.35749 13.2913 6.29164 13.1323 6.29164 12.9666Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.INVENTORY_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <inventory-module-menu class="sub-menu"></inventory-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_FILE_EXPLORER)"
          :to="{ name: 'Files Explorer' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="17"
                height="18"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.0926 16.1363L11.2779 17.3218C11.3832 17.4235 11.5243 17.4798 11.6707 17.4785C11.817 17.4772 11.9571 17.4185 12.0606 17.315C12.1641 17.2115 12.2228 17.0714 12.2241 16.925C12.2254 16.7786 12.1691 16.6375 12.0674 16.5322L10.9301 15.3948C11.4116 14.7998 11.6738 14.0573 11.6727 13.2919C11.6727 11.443 10.1713 9.94153 8.32266 9.94153C6.47346 9.94153 4.97266 11.443 4.97266 13.2919C4.97304 13.8892 5.13305 14.4756 5.43612 14.9903C5.73919 15.5051 6.17431 15.9294 6.69644 16.2195C7.21857 16.5096 7.80873 16.6548 8.40583 16.6402C9.00293 16.6256 9.58527 16.4516 10.0926 16.1363ZM8.32266 11.0583C9.55546 11.0583 10.556 12.0595 10.556 13.2919C10.556 14.5248 9.55546 15.5254 8.32266 15.5254C7.08986 15.5254 6.08933 14.5248 6.08933 13.2919C6.08933 12.0595 7.08986 11.0583 8.32266 11.0583Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.11667 7.48638L15.6333 7.49978V11.4616C15.6325 11.5269 15.6185 11.5914 15.5921 11.6512C15.5658 11.711 15.5275 11.7648 15.4798 11.8094C15.37 11.9118 15.2251 11.9682 15.075 11.9669H13.4329C13.2892 11.9733 13.1534 12.035 13.054 12.139C12.9545 12.243 12.899 12.3814 12.899 12.5253C12.899 12.6692 12.9545 12.8076 13.054 12.9116C13.1534 13.0156 13.2892 13.0773 13.4329 13.0837H15.075C15.5161 13.0837 15.9382 12.9151 16.2497 12.618C16.4072 12.4693 16.5328 12.29 16.6188 12.0912C16.7048 11.8924 16.7494 11.6782 16.75 11.4616V4.54868C16.75 4.11537 16.5713 3.69825 16.2492 3.39225C15.9317 3.09218 15.5112 2.92548 15.0744 2.92655L8.9378 2.92879C8.75913 2.92879 8.5894 2.85229 8.4822 2.71604L7.48055 1.43956C7.32112 1.23901 7.11833 1.07719 6.88741 0.966263C6.65648 0.855334 6.40343 0.798176 6.14725 0.799083H1.675C0.742583 0.799083 0 1.53281 0 2.42121V11.4616C0 12.35 0.742583 13.0837 1.675 13.0837H3.33939C3.48747 13.0837 3.62949 13.0249 3.73419 12.9201C3.8389 12.8154 3.89773 12.6734 3.89773 12.5253C3.89773 12.3772 3.8389 12.2352 3.73419 12.1305C3.62949 12.0257 3.48747 11.9669 3.33939 11.9669H1.675C1.37406 11.9669 1.11667 11.7486 1.11667 11.4616V7.48638ZM15.6333 6.38299V4.54868C15.6326 4.48328 15.6185 4.41871 15.592 4.35891C15.5655 4.2991 15.5272 4.24531 15.4792 4.2008C15.3697 4.09835 15.225 4.04197 15.075 4.04334L8.9378 4.04557C8.68151 4.04668 8.4283 3.98962 8.19725 3.87868C7.96621 3.76774 7.76334 3.60581 7.60394 3.40509L6.60229 2.12917C6.54745 2.06158 6.47803 2.00729 6.39922 1.97035C6.32042 1.93341 6.23428 1.91478 6.14725 1.91587H1.675C1.37406 1.91587 1.11667 2.1342 1.11667 2.42121V6.36959L15.6333 6.38299Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.FILE_EXPLORER_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <files-explorer-module-menu></files-explorer-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_RESELLER)"
          :to="{ name: 'Reseller Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.27408 12.1332V15.0516C9.27408 15.3966 9.55324 15.6766 9.89908 15.6766H14.6107C14.7765 15.6766 14.9355 15.6107 15.0527 15.4935C15.1699 15.3763 15.2357 15.2173 15.2357 15.0516V12.1332H16.4857V15.0516C16.4857 15.5489 16.2882 16.0258 15.9366 16.3774C15.5849 16.729 15.108 16.9266 14.6107 16.9266H9.89908C9.4018 16.9266 8.92488 16.729 8.57325 16.3774C8.22162 16.0258 8.02408 15.5489 8.02408 15.0516V12.1332H9.27408Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.78737 8.13066C9.74533 8.1307 9.70429 8.14345 9.66964 8.16725C9.63498 8.19105 9.60834 8.22477 9.5932 8.26399L8.6982 10.5982C8.57904 10.9207 8.57154 11.1565 8.61154 11.3148C8.64737 11.4565 8.7332 11.5865 8.92404 11.6965C9.27654 11.9007 9.72654 11.7798 9.92987 11.4273L10.3507 10.6982C10.4194 10.5788 10.5256 10.4855 10.6528 10.4327C10.78 10.3799 10.9211 10.3706 11.0541 10.4062C11.1871 10.4419 11.3046 10.5204 11.3884 10.6297C11.4722 10.739 11.5175 10.8729 11.5174 11.0107C11.5174 11.299 11.6024 11.544 11.729 11.7023C11.8424 11.8465 12.0049 11.9432 12.254 11.9432C12.5032 11.9432 12.6657 11.8465 12.779 11.7032C12.9057 11.544 12.9907 11.299 12.9907 11.0107C12.9906 10.8729 13.0359 10.739 13.1197 10.6297C13.2034 10.5204 13.321 10.4419 13.454 10.4062C13.587 10.3706 13.7281 10.3799 13.8553 10.4327C13.9825 10.4855 14.0887 10.5788 14.1574 10.6982L14.5782 11.4273C14.676 11.5963 14.8368 11.7196 15.0254 11.7701C15.214 11.8205 15.4149 11.7941 15.584 11.6965C15.7757 11.5865 15.8607 11.4573 15.8965 11.3148C15.9365 11.1565 15.9299 10.9207 15.8107 10.5982L14.9149 8.26482C14.8997 8.2256 14.8731 8.19188 14.8384 8.16808C14.8038 8.14429 14.7627 8.13153 14.7207 8.13149L9.78737 8.13066ZM8.4257 7.81649C8.53139 7.54109 8.71812 7.30421 8.96122 7.13713C9.20433 6.97005 9.49239 6.88063 9.78737 6.88066H14.7207C15.0158 6.88069 15.3039 6.97024 15.547 7.13748C15.7902 7.30471 15.9768 7.54177 16.0824 7.81732L16.9815 10.1607C17.1599 10.6415 17.229 11.1465 17.1082 11.6223C16.9832 12.1157 16.6699 12.514 16.209 12.779C15.8256 13.0004 15.3792 13.0875 14.9406 13.0264C14.502 12.9652 14.0965 12.7594 13.7882 12.4415C13.6096 12.6784 13.3777 12.8699 13.1113 13.0005C12.8449 13.1311 12.5515 13.1971 12.2549 13.1932C11.9577 13.1985 11.6636 13.1332 11.3967 13.0025C11.1298 12.8718 10.8978 12.6795 10.7199 12.4415C10.4116 12.7594 10.006 12.9652 9.56747 13.0264C9.12891 13.0875 8.68249 13.0004 8.29904 12.779C7.8382 12.5132 7.5257 12.1157 7.39987 11.6223C7.27904 11.1473 7.3482 10.6415 7.52737 10.1607L7.52987 10.154L8.4257 7.81649Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.13076 9.71983C3.56098 9.71983 3.01454 9.94618 2.61165 10.3491C2.20876 10.752 1.98242 11.2984 1.98242 11.8682C1.98242 12.4379 2.20876 12.9844 2.61165 13.3873C3.01454 13.7902 3.56098 14.0165 4.13076 14.0165H8.71409V15.2665H4.13076C3.68448 15.2665 3.24257 15.1786 2.83027 15.0078C2.41796 14.837 2.04334 14.5867 1.72777 14.2712C1.41221 13.9556 1.16189 13.581 0.991105 13.1687C0.820322 12.7563 0.732422 12.3144 0.732422 11.8682C0.732422 11.4219 0.820322 10.98 0.991105 10.5677C1.16189 10.1554 1.41221 9.78075 1.72777 9.46518C2.04334 9.14962 2.41796 8.8993 2.83027 8.72852C3.24257 8.55773 3.68448 8.46983 4.13076 8.46983H8.71409V9.71983H4.13076ZM6.90242 2.1415C6.64465 2.1415 6.3894 2.19227 6.15125 2.29092C5.91309 2.38956 5.6967 2.53415 5.51443 2.71643C5.33216 2.8987 5.18757 3.11509 5.08892 3.35324C4.99028 3.59139 4.93951 3.84664 4.93951 4.10442C4.93951 4.36219 4.99028 4.61744 5.08892 4.85559C5.18757 5.09374 5.33216 5.31013 5.51443 5.49241C5.6967 5.67468 5.91309 5.81927 6.15125 5.91792C6.3894 6.01656 6.64465 6.06733 6.90242 6.06733C7.42291 6.06733 7.92208 5.86057 8.29012 5.49253C8.65816 5.12449 8.86492 4.62532 8.86492 4.10483C8.86492 3.58435 8.65816 3.08518 8.29012 2.71714C7.92208 2.3491 7.42291 2.1415 6.90242 2.1415ZM3.68992 4.10483C3.68992 3.25283 4.02838 2.43571 4.63084 1.83325C5.2333 1.23079 6.05041 0.892334 6.90242 0.892334C7.75443 0.892334 8.57154 1.23079 9.174 1.83325C9.77646 2.43571 10.1149 3.25283 10.1149 4.10483C10.1149 4.95684 9.77646 5.77395 9.174 6.37641C8.57154 6.97887 7.75443 7.31733 6.90242 7.31733C6.05041 7.31733 5.2333 6.97887 4.63084 6.37641C4.02838 5.77395 3.68992 4.95684 3.68992 4.10483Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.RESELLER_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <reseller-module-menu></reseller-module-menu>
            </span>
          </a>
        </router-link>
      </li>
      <li>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_APP_ADMIN)"
          :to="{ name: 'Admin Page' }"
          v-slot="{ href, navigate, isActive }"
          custom
        >
          <a
            :href="href"
            @click="navigate"
            :class="{ 'active-link': isActive }"
          >
            <span class="icon">
              <svg
                width="16"
                height="19"
                viewBox="0 0 16 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.82 10.2984V7.12169L13.8997 6.66449C13.8128 6.41056 13.7099 6.16243 13.5915 5.92162L14.6263 4.23998L12.38 1.99369L10.6984 3.02856C10.4576 2.91013 10.2095 2.80719 9.95556 2.72039L9.49836 0.800049H6.32167L5.86444 2.72039C5.61052 2.80719 5.3624 2.91013 5.1216 3.02856L3.43997 1.99369L1.19364 4.23998L2.22848 5.92162C2.11005 6.16243 2.00712 6.41056 1.9203 6.66449L0 7.12165V10.2984L1.92034 10.7556C2.00715 11.0095 2.11009 11.2577 2.22851 11.4985L1.18879 13.188L2.74632 14.6799C2.5804 15.1773 2.49589 15.6982 2.49604 16.2225V18.5536H13.3943V16.2225C13.3943 15.7126 13.3143 15.2101 13.1602 14.7307L14.6187 13.1677L13.5915 11.4985C13.7099 11.2577 13.8129 11.0096 13.8997 10.7556L15.82 10.2984ZM12.3396 17.4989H3.55071V16.2225C3.55071 15.4911 3.75911 14.7788 4.15342 14.1627C4.85927 13.0598 6.06243 12.4014 7.37187 12.4014H8.51844C9.82788 12.4014 11.031 13.0598 11.7369 14.1627C12.1308 14.7775 12.34 15.4924 12.3396 16.2225V17.4989ZM7.94516 11.3028C6.60035 11.3028 5.50624 10.2087 5.50624 8.86385C5.50624 7.51905 6.60035 6.42494 7.94516 6.42494C9.28996 6.42494 10.3841 7.51905 10.3841 8.86385C10.3841 10.2087 9.28996 11.3028 7.94516 11.3028ZM13.2992 13.0358L12.686 13.693C12.6659 13.66 12.6461 13.6268 12.6252 13.5942C12.0204 12.6491 11.1291 11.9604 10.103 11.6095C10.9159 10.9693 11.4387 9.97649 11.4387 8.86385C11.4387 6.93751 9.87147 5.37027 7.94512 5.37027C6.01877 5.37027 4.45154 6.93751 4.45154 8.86385C4.45154 9.97649 4.97437 10.9693 5.78724 11.6095C4.76115 11.9604 3.86989 12.6491 3.26504 13.5942C3.2488 13.6196 3.2335 13.6455 3.21775 13.6711L2.53327 13.0155L3.44517 11.5336L2.75542 9.87036L1.05467 9.46537V7.9547L2.75546 7.54974L3.44521 5.88646L2.52842 4.39671L3.59662 3.32851L5.08641 4.24529L6.74969 3.55554L7.15468 1.85472H8.66535L9.07031 3.55551L10.7336 4.24529L12.2233 3.32851L13.2915 4.39671L12.3748 5.88646L13.0645 7.54974L14.7653 7.9547V9.46537L13.0645 9.87032L12.3748 11.5336L13.2992 13.0358Z"
                  fill="white"
                />
              </svg>
            </span>
            <span class="text">
              {{ $t("APPS.ADMIN_MODULE") }}
            </span>
            <span class="sub-menu-wrapper">
              <admin-module-menu></admin-module-menu>
            </span>
          </a>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import AdminModuleMenu from "../../../Pages/AdminModule/AdminModuleMenu.vue";
import CrmModuleMenu from "../../../Pages/CrmModule/CrmModuleMenu.vue";
import ElixioPayModuleMenu from "../../../Pages/ElixioPayModule/ElixioPayModuleMenu.vue";
import SyncModuleMenu from "../../../Pages/SyncModule/SyncModuleMenu.vue";
import EsignModuleMenu from "../../../Pages/EsignModule/EsignModuleMenu.vue";
import DpaModuleMenu from "../../../Pages/DpaModule/DpaModuleMenu.vue";
import FilesExplorerModuleMenu from "../../../Pages/FilesExplorerModule/FilesExplorerModuleMenu.vue";
import InventoryModuleMenu from "../../../Pages/InventoryModule/InventoryModuleMenu.vue";
import PurchasesModuleMenu from "../../../Pages/PurchasesModule/PurchasesModuleMenu.vue";
import ResellerModuleMenu from "../../../Pages/ResellerModule/ResellerModuleMenu.vue";
import SalesModuleMenu from "../../../Pages/SalesModule/SalesModuleMenu.vue";
import AuctionsModuleMenu from "../../../Pages/AuctionsModule/AuctionsModuleMenu";
import EsignIcon from "@/components/Icons/EsignIcon.vue";
export default {
  components: {
    AdminModuleMenu,
    ResellerModuleMenu,
    FilesExplorerModuleMenu,
    InventoryModuleMenu,
    SalesModuleMenu,
    PurchasesModuleMenu,
    CrmModuleMenu,
    SyncModuleMenu,
    EsignModuleMenu,
    DpaModuleMenu,
    ElixioPayModuleMenu,
  },

  props: {},

  async created() {},

  computed: {},

  data() {
    return {};
  },

  methods: {},
};
</script>
